import { apiDomain } from "./constants";
import api from "./api";

export async function removeConsumablesFromStock(consumableItems) {
  const { data } = await api.put(`${apiDomain}/consumables/out`, { items: consumableItems });
  return data;
}
